module.exports = __webpack_public_path__ + "img/1.c01dd51e.jpg";